import { supabase } from "@fd/supabase/index";

export const getAccessToken = async () => {
  const { data, error } = await supabase.auth.getSession();
  if (error) {
    throw Error(error.message);
  }
  return data.session?.access_token;
};

export const isLoggedIn = async () => {
  const { data } = await supabase.auth.getSession();
  return data.session !== null;
};

export const getUser = async () => {
  const { data } = await supabase.auth.getSession();
  return data.session?.user;
};
